var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFlow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.083 7.833a1.583 1.583 0 1 0 0-3.166 1.583 1.583 0 0 0 0 3.167zm0 1.334a2.917 2.917 0 1 0-2.908-3.144c-.287.036-.6.117-.903.259-.755.353-1.439 1.09-1.439 2.314 0 .358.006.67.012.964.006.328.011.632.008.946-.006.563-.046.987-.146 1.307-.093.298-.228.479-.433.603-.11.068-.258.13-.459.174a2.917 2.917 0 1 0-.177 1.378c.515-.056.959-.187 1.33-.413.538-.327.845-.807 1.012-1.345.16-.515.2-1.101.206-1.689a38.11 38.11 0 0 0-.009-1.024c-.005-.303-.01-.612-.01-.901 0-.626.306-.936.67-1.106.177-.083.369-.13.54-.148a2.918 2.918 0 0 0 2.706 1.825zM5.917 14.5a1.583 1.583 0 1 0 0-3.167 1.583 1.583 0 0 0 0 3.167z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlow);
export default __webpack_public_path__ + "static/media/ic-flow.bb598d895b6916b9b6ceaa38448d958e.svg";
export { ForwardRef as ReactComponent };